import {ClientNotesRecords} from "../../../models/ClientNotesRecord";

export interface ClientNotesChange {
    readonly type: ClientNotesChangeType;
}

export enum ClientNotesChangeType {
    REFRESH,
    ADD_NOTE,
    REMOVE_NOTE,
    EDIT_NOTE
}

export interface RefreshNotesChange extends ClientNotesChange {
    readonly type: ClientNotesChangeType.REFRESH;
}

export function refreshNotesChange(): RefreshNotesChange {
    return {
        type: ClientNotesChangeType.REFRESH
    };
}

export function isRefreshChange(change: ClientNotesChange): change is RefreshNotesChange {
    return change.type === ClientNotesChangeType.REFRESH;
}

export interface AddNoteChange extends ClientNotesChange {
    readonly type: ClientNotesChangeType.ADD_NOTE;
    readonly content: string;
    readonly noteTag: string;
}

export function addNoteChange(content: string, noteTag: string): AddNoteChange {
    return {
        type: ClientNotesChangeType.ADD_NOTE,
        content,
        noteTag
    };
}

export function isAddNoteChange(change: ClientNotesChange): change is AddNoteChange {
    return change.type === ClientNotesChangeType.ADD_NOTE;
}

export interface RemoveNoteChange extends ClientNotesChange {
    readonly type: ClientNotesChangeType.REMOVE_NOTE;
    readonly id: number;
}

export function removeNoteChange(id: number): RemoveNoteChange {
    return {
        type: ClientNotesChangeType.REMOVE_NOTE,
        id
    };
}

export function isRemoveNoteChange(change: ClientNotesChange): change is RemoveNoteChange {
    return change.type === ClientNotesChangeType.REMOVE_NOTE;
}

export interface EditNoteChange extends ClientNotesChange {
    readonly type: ClientNotesChangeType.EDIT_NOTE;
    readonly noteId: number;
    readonly content: string;
    readonly noteTag: string;
}

export function editNoteChange(noteId: number, content: string, noteTag: string): EditNoteChange {
    return {
        type: ClientNotesChangeType.EDIT_NOTE,
        noteId,
        content,
        noteTag
    };
}

export function isEditNoteChange(change: ClientNotesChange): change is EditNoteChange {
    return change.type === ClientNotesChangeType.EDIT_NOTE;
}
